import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.updateActiveButton()
  }

  toggle(event) {
    this.updateActiveButton()
  }

  updateActiveButton() {
    this.buttonTargets.forEach(button => {
      button.classList.toggle('active', this.normalizeViewUrl(button.href) === this.normalizeViewUrl(window.location.href))
    })
  }

  normalizeViewUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.origin)
      const view = parsedUrl.searchParams.get('view')

      if (view === 'steps') {
        parsedUrl.searchParams.set('view', 'pipeline')
      }

      return parsedUrl.toString()
    } catch (_error) {
      return url
    }
  }
}
